<template>
  <div>
    <div class="app-card-header primary-actions">
      <div class="heading-block">
        <h4 class="heading">Availability Tracking</h4>
      </div>
      <div class="actions-block">
        <!--Seller Select-->
        <div class="dropdown-filter">
          <v-autocomplete
            :value="chart.sellers.checked"
            :items="chart.sellers.all"
            :loading="filters.seller.isLoading"
            :ripple="false"
            :disabled="copyChart().status.loading"
            background-color="rgba(48, 127, 255, 0.1)"
            clearable
            hide-details
            clear-icon
            placeholder="Sellers"
            append-icon="expand_more"
            item-text="name"
            item-value="id"
            label="Seller"
            solo
            flat
            multiple
            class="placeholder-hardcoded"
            @change="checkSeller($event)"
          >
            <template v-slot:selection="data">
            </template>
          </v-autocomplete>
        </div>
        <!--Date Pick-->
        <div class="dropdown-filter min">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                flat
                small
                :ripple="false"
                :disabled="copyChart().status.loading"
                v-on="on"
              >
                <v-icon class="mr-1">event</v-icon>{{filters.date.modelText}}
              </v-btn>
            </template>
            <v-list>
              <v-list-tile
                v-for="(item, index) in filters.date.items"
                :key="index"
                @click="filterDate($event, item.key, item.value)"
              >
                <v-list-tile-title>{{ item.value }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>
    <div class="card-body pa-0"
         @mousemove="updateTooltips"
         @click="updateTooltips">
      <v-progress-circular
        v-if="copyChart().status.loading && copyChart().status.noData"
        :indeterminate="true"
        :size="75"
        height="3"
        color="primary"
        class="progress-circular" />
      <v-progress-linear
        v-if="copyChart().status.loading && copyChart().series.length > 0"
        :indeterminate="true"
        height="3"
        color="primary"
        class="progress-card" />
      <apexchart
        v-if="!copyChart().status.noData"
        type="area"
        ref="availabilityTrackingChart"
        class="line-chart"
        height="420"
        @updated="mutateYaxis"
        :options="copyChart()"
        :series="copyChartSeries()" />
      <i-no-data v-if="copyChart().status.noData && !copyChart().status.loading" title="No data found or no mapping" heading="Oops!" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'availabilityTracking',
  props: {
    filters: {
      type: [Object, Array],
      default: null
    },
    chart: {
      type: [Object, Array],
      default: null
    },
    currentProduct: {
      type: [Object, Array],
      default: null
    },
    currentSku: {
      type: [Object, Array],
      default: null
    }
  },
  methods: {
    filterDate (e, key, value) {
      this.filters.date.model = key
      this.filters.date.modelText = value
    },
    copyChart () {
      return JSON.parse(JSON.stringify(this.chart.chartOptions))
    },
    copyChartSeries () {
      return JSON.parse(JSON.stringify(this.chart.chartOptions.series))
    },
    mutateYaxis () {
      if (this.copyChart().series.length > 0 && this.copyChart().xaxis.categories.length > 0 && this.$refs.availabilityTrackingChart) {
        let vals = this.$refs.availabilityTrackingChart.$el.querySelectorAll('.apexcharts-yaxis text')
        vals.forEach(e => {
          if (e.innerHTML === '2.0') e.innerHTML = 'In Stock'
          else if (e.innerHTML === '1.0') e.innerHTML = 'Limited'
          else if (e.innerHTML === '0.0') e.innerHTML = 'No Stock'
        })
      }
    },
    updateTooltips () {
      if (this.$refs.availabilityTrackingChart) {
        let tooltipVals = this.$refs.availabilityTrackingChart.$el.querySelectorAll('.apexcharts-tooltip-text .apexcharts-tooltip-y-group .apexcharts-tooltip-text-value')
        tooltipVals.forEach(e => {
          if (e.innerHTML === '2.0') e.innerHTML = 'In Stock'
          else if (e.innerHTML === '1.0') e.innerHTML = 'Limited'
          else if (e.innerHTML === '0.0') e.innerHTML = 'No Stock'
        })
      }
    },
    checkSeller (items) {
      this.$store.commit('productViewModule/ADD_availabilityTrackingSellers', {item: items})
      this.$store.dispatch('productViewModule/getAvailabilityTracking', {
        productId: this.currentProduct.id,
        sku: this.currentSku.sku,
        sellerId: items,
        altDate: this.filters.date.model,
        moduleId: 2,
        chartRef: this.$refs.availabilityTrackingChart
      })
    }
  },
  watch: {
    'filters.seller.search': function (val) {
      if (val === '' || val === null) {
        this.filters.seller.model = 0
        return
      }
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.filters.seller.isLoading = true
        this.$store.dispatch('productViewModule/getAvailabilityTrackingSellers', {
          sellerName: val,
          productId: this.currentProduct.id,
          sku: this.currentSku.id,
          dateOption: this.filters.date.model,
          pageId: 'product_av'
        }).then(() => {
          this.filters.seller.isLoading = false
        })
      }, 300)
    },
    'filters.date.model': function (val) {
      this.$store.dispatch('productViewModule/getAvailabilityTracking', {
        productId: this.currentProduct.id,
        sku: this.currentSku.sku,
        sellerId: this.filters.seller.model,
        altDate: this.filters.date.model,
        moduleId: 2,
        chartRef: this.$refs.availabilityTrackingChart
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/productView/availabilityTracking.vue